// constants/theme.js
export const colors = {
  // Primary Colors
  primary: "#667eea",
  secondary: "#764ba2",

  // Gradient
  gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  gradientHover: "linear-gradient(135deg, #5568d3 0%, #653a8b 100%)",

  // Background Colors
  bgLight: "#f9fafb",
  bgWhite: "#ffffff",
  bgGray: "#f3f4f6",

  // Border Colors
  border: "#e5e7eb",
  borderLight: "#f3f4f6",
  borderDark: "#d1d5db",

  // Text Colors
  textDark: "#333333",
  textMedium: "#6b7280",
  textLight: "#9ca3af",
  textMuted: "#9ca3af",

  // State Colors
  success: "#10b981",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",

  // Hover States
  hoverBg: "rgba(102, 126, 234, 0.1)",
  hoverBorder: "#667eea",

  // Shadow
  shadowPrimary: "0 10px 20px rgba(102, 126, 234, 0.3)",
  shadowLight: "0 1px 3px rgba(0, 0, 0, 0.1)",
  shadowMedium: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

// Style helpers
export const getGradientStyle = (opacity = 1) => ({
  background: colors.gradient,
  opacity,
});

export const getHoverEffect = (type = "primary") => {
  const effects = {
    primary: {
      transform: "translateY(-2px)",
      boxShadow: colors.shadowPrimary,
    },
    subtle: {
      backgroundColor: colors.hoverBg,
    },
    border: {
      borderColor: colors.hoverBorder,
      boxShadow: `0 0 0 3px ${colors.hoverBg}`,
    },
  };
  return effects[type] || effects.primary;
};

export const getButtonStyle = (variant = "primary", size = "md") => {
  const sizes = {
    sm: { padding: "6px 16px", fontSize: "14px" },
    md: { padding: "10px 20px", fontSize: "16px" },
    lg: { padding: "12px 24px", fontSize: "18px" },
  };

  const variants = {
    primary: {
      background: colors.gradient,
      color: "#fff",
      border: "none",
    },
    outline: {
      background: "transparent",
      color: colors.primary,
      border: `2px solid ${colors.primary}`,
    },
    secondary: {
      background: colors.bgGray,
      color: colors.textDark,
      border: `1px solid ${colors.border}`,
    },
  };

  return {
    ...variants[variant],
    ...sizes[size],
    borderRadius: "8px",
    transition: "all 0.3s",
    fontWeight: "600",
  };
};

export const getInputStyle = (hasError = false) => ({
  border: `1px solid ${hasError ? colors.error : colors.border}`,
  borderRadius: "8px",
  transition: "all 0.2s",
  ":focus": {
    borderColor: colors.primary,
    boxShadow: `0 0 0 3px ${colors.hoverBg}`,
  },
});

export const getCardStyle = () => ({
  background: colors.bgWhite,
  borderRadius: "8px",
  border: `1px solid ${colors.border}`,
  boxShadow: colors.shadowLight,
});

// Ant Design theme customization
export const antdTheme = {
  token: {
    colorPrimary: colors.primary,
    colorLink: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.error,
    colorInfo: colors.info,
    borderRadius: 8,
    colorBorder: colors.border,
    colorBgContainer: colors.bgWhite,
  },
};

// CSS-in-JS helpers
export const spacing = {
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "48px",
};

export const breakpoints = {
  xs: "576px",
  sm: "768px",
  md: "992px",
  lg: "1200px",
  xl: "1400px",
};
